import type { FormDataOf } from '../../../../../types/templates';
import { GroupedSelection } from '../../../../../types/form/grouped-selection';
import { Team } from '../../../../../types/sport';
import { disneyEspnHero } from '..';
import { ESPN_HERO_LEAGUES } from '../data/leagues';
import { getPlayerImageUrl } from '../urls';

type FormData = FormDataOf<typeof disneyEspnHero>;

const MAX_TEAMS = 2;
const MAX_PLAYERS_PER_TEAM = 2;

/** Genera los defaults de jugadores para un equipo: los primeros N, con su primera imagen. */
const buildDefaultPlayersForTeam = (league: string, team: Team | undefined): GroupedSelection[] => {
  if (!team) return [];
  return team.players.slice(0, MAX_PLAYERS_PER_TEAM).map(player => ({
    groupId: team.value,
    itemValue: player.value,
    subImage: player.images?.[0] ? getPlayerImageUrl(league, team.value, player.value, player.images[0]) : undefined
  }));
};

/**
 * Defaults derivados para el canvas. Permite que al cambiar de liga se vea en
 * el canvas un conjunto coherente de jugadores (primeros 2 equipos, primeros
 * 2 jugadores c/u) sin ensuciar el formData (el formulario queda vacío y el
 * usuario puede elegir libremente).
 */
export const computeDefaults = (formData: FormData, _resolutionId?: string): Partial<FormData> => {
  const { league } = formData;
  if (!league) return {};

  const leagueData = ESPN_HERO_LEAGUES.find(l => l.value === league);
  const [team1, team2] = (leagueData?.teams ?? []).slice(0, MAX_TEAMS);

  return {
    players: [...buildDefaultPlayersForTeam(league, team1), ...buildDefaultPlayersForTeam(league, team2)]
  };
};
